import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { useAuth } from 'contexts/AuthContext';

export default function BranchBanner() {
  const { t } = useTranslation();
  const { user, switchTenant } = useAuth();
  const [busy, setBusy] = useState(false);

  if (!user?.switched || user.isHomeChild) return null;

  const back = async () => {
    setBusy(true);
    try {
      await switchTenant(user.homeTenantId);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Alert
      severity="info"
      sx={{ mb: 2 }}
      action={
        <Button color="inherit" size="small" onClick={back} disabled={busy}>
          {t('tenants.backToHeadquarters')}
        </Button>
      }
    >
      {t('tenants.youAreIn', { name: user.currentTenantName })}
    </Alert>
  );
}
